

@if (!customizableMode) {
    <p-card>
        <div class="padding15">
            <div class="module-flex-row-with-space">
                <div class="module-title">
                    <div class="module-title-label">Clients</div>
                    <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showPortfolios()" >
                </div>
                <div>
                    <a (click)="showCreatePortfolio()" style="font-size: 14px;">Create a Portfolio</a>
                </div>
            </div>
            @if (!data) {
                <div class='loading-spinner'></div>
            }
            @if (data) {
                <div style="margin-top: 40px;border-bottom: 1px solid #E1E8ED;">
                    <div class="module-flex-row-with-space">
                        <div class="client-panel-label">Unassigned Accounts</div>
                        <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showUnassignedAccounts()" >
                    </div>
                    <div class="client-module-details-numbers" >
                        {{data.unassignedAccountCount}} / ${{data.unassignedAccountValue | number}}
                    </div>
                </div>

                <div style="margin-top: 15px;border-bottom: 1px solid #E1E8ED;">
                    <div class="module-flex-row-with-space">
                        <div class="client-panel-label">Portfolios with Pending Rebalance Results</div>
                        <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showPortfoliosWithPendingResults()" >
                    </div>
                    <div class="client-module-details-numbers" >
                        {{data.portPendingResultsCount | number}}
                    </div>
                </div>

                <div style="margin-top: 15px;">
                    <div class="module-flex-row-with-space">
                        <div class="client-panel-label">30 Day Tax Harvest Expiration (Last 7 Days)</div>
                        <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showTaxHarvestExpiration()" >
                    </div>
                    <div class="client-module-details-numbers" >
                        {{data.taxHarExpCount | number}}
                    </div>
                </div>
            }
        </div>
    </p-card>
}
    @if (customizableMode) {
        <div style="padding: 25px 10px 0 10px;">
            <div class="module-flex-row-with-space">
                <div class="skeleton-styles-rectangle" style="width:60%;"></div>
                <div class="skeleton-styles-circle"></div>
            </div>
            <div class="skeleton-styles-rectangle" style="margin-top: 10px; width:35%;"></div>

            <div class="module-flex-row-with-space" style="margin-top:30px;">
                <div class="skeleton-styles-rectangle" style="width:65%;"></div>
                <div class="skeleton-styles-circle"></div>
            </div>
            <div class="skeleton-styles-rectangle" style="margin-top: 10px; width:20%;"></div>

            <div class="module-flex-row-with-space" style="margin-top:30px;">
                <div class="skeleton-styles-rectangle" style="width:70%;"></div>
                <div class="skeleton-styles-circle"></div>
            </div>
            <div class="skeleton-styles-rectangle" style="margin-top: 10px; width:20%;"></div>
        </div>

    }

